import type { CSSProperties } from 'react';
import className from 'classnames/bind';

import { useVideoPrivacy } from '@/providers/VideoPrivacyContext';

import staticNoise from '@/assets/images/static-noise.png';

import styles from './ConsentGate.module.scss';
import { usePageWrapperData } from '@/providers/PageWrapperContext';
import { Button } from '@/components/Button';
const cx = className.bind(styles);
type ConsentGateProps = {
  youtubeId: string;
  className?: string;
  consentSmall?: boolean;
  consentToken?: string;
};

const ConsentGate = ({ youtubeId, className, consentSmall, consentToken }: ConsentGateProps) => {
  const { accept } = useVideoPrivacy();
  const { labels } = usePageWrapperData();
  const { consentGate } = labels;

  return (
    <div
      className={cx(['consent-gate', className])}
      // Resolved by webpack at build time; the animation itself lives in SCSS
      style={{ '--consent-gate-static': `url(${staticNoise.src})` } as CSSProperties}
    >
      <div className={cx('consent-gate__text')}>
        <div
          className={cx('consent-gate__headline', consentSmall ? 'title-lc-xs' : 'title-lc-s')}
          dangerouslySetInnerHTML={{ __html: consentGate?.headline || '' }}
        />
        {consentGate?.subhead && (
          <div
            className={cx('consent-gate__subhead', consentSmall ? 'text-m' : 'title-lc-xs')}
            dangerouslySetInnerHTML={{ __html: consentGate.subhead }}
          />
        )}
      </div>
      <div className={cx('consent-gate__actions')}>
        <Button
          onClick={() => accept(consentToken)}
          label={consentGate?.ctaLabel || 'Accept Cookies'}
        />
      </div>
    </div>
  );
};

export default ConsentGate;


